var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({staticClass:"iconfont",style:(_vm.style),attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":'#icon-' + _vm.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }